
export default {
  login: 'INGRESAR A LA PLATAFORMA',
  problems_to_login: '¿Problemas para ingresar al sistema?',
  recover_password: 'Recuperar contraseña',
  go_back: 'Volver',
  email_not_found: 'Dirección de correo {email} no encontrada.',
  unexpected_error: 'Ocurrió un error inesperado. Si el problema persiste contacte al administrador.',
  password_successfully_restablish: 'Restablecimiento de contraseña exitoso',
  password_sent_to_email: 'Su nueva contraseña ha sido enviada a su correo electrónico.',
  // tslint:disable-next-line:max-line-length
  password_notification_sent: 'Notificación enviada al administrador para seguir con el restablecimiento de su contraseña.',
  accept: 'Aceptar',
  password_not_updated: 'Lo sentimos, su contraseña no fue actualizada.',
  password_confirm: 'Confirmar contraseña',
  password_confirmation: 'Confirmación de contraseña',
  new_password: 'Nueva contraseña',
  new_password_confirm: 'Confirmar nueva contraseña',
  save_new_password: 'Guardar nueva contraseña',
  password_update: 'Actualización de contraseña.',
  password_updated: 'Su contraseña ha sido actualizada correctamente.',
  password_reset_requested: 'Reseteo de contraseña solicitado',
  check_your_email: 'Hemos enviado un correo electrónico a la dirección especificada con los pasos a seguir.',
  create_password: 'Crear contraseña',
  save_password: 'Guardar contraseña',
  password_create: 'Creación de contraseña',
  password_created: 'Contraseña creada',
  password_not_created: 'Lo sentimos, su contraseña no pudo se creada.',
  password_created_greet_title: 'Su contraseña fue creada exitosamente',
  // tslint:disable-next-line:max-line-length
  password_created_greet_text: 'Ahora puede utilizar su correo electrónico y esta nueva contraseña para ingresar al sistema',
  token_not_valid: 'El código de verificación es inválido',
  // tslint:disable-next-line:max-line-length
  token_expired: 'Este código expiró, recuerde que por su seguridad nuestos códigos de acceso solo poseen un máximo de tres días de vigencia.',
  token_used: 'Este código ya ha sido utilizado.',
  // tslint:disable-next-line:max-line-length
  verify_or_contact: 'Verifique el código o enlace que ha utilizado e intente nuevamente. También puede ponerse en contactos con OCC Solutions para más información.',
  go_sign_in: 'Volver al inicio de sesión',
  logged_as_enterprise: 'Sesión temporal como empresa',
  logged_as_employee: 'Sesión temporal como empleado',
  logged_as_customer: 'Sesión temporal como cliente',
  close_session: 'Cerrar sesión',
  sign_up: 'Registro',
  select_customer_title: 'Seleccione la cuenta que mejor se adapte a sus necesidades.',
  select_customer_personal: 'Cuenta Única empresa',
  select_customer_personal_text: 'Puedes registrarte como administrador y registrar a tu empresa para gestionarla de forma personal',
  select_customer_personal_select: 'Seleccionar',
  select_customer_commercial: 'Cuenta Multi Empresas',
  select_customer_commercial_text: 'Puedes registrarte como administrador para gestionar y administrar multilpes empresas',
  select_customer_commercial_select: 'Seleccionar',
  has_no_account: '¿Aún no tienes cuenta?',
  customer_personal_d: 'Puedes registrarte como administrador y registrar a tu empresa para gestionarla de forma personal.',
  customer_commercial_d: 'Puedes registrarte como administrador para gestionar y administrar multilpes empresas.',
  // tslint:disable-next-line:max-line-length
  customer_personal_d_2: 'Registra un usuario como administrador junto a su empresa para gestionarla de forma personal.',
  customer_commercial_d_2: 'Registra un usuario como administrador de multilpes empresas.',
  personal_account: 'Cuenta Única Empresa',
  commercial_account: 'Cuenta Multi Empresas',
  terms_and_confitions_header: 'Términos y condiciones de uso personal',
  terms_and_confitions_changed_header: 'Hemos cambiado nuestros Términos y condiciones de uso personal',
  confirm_logout: '¿Estás seguro que deseas cerrar sesión?'
}
